import { LANGUAGE_EN, LANGUAGE_EN_US } from '../constants/language'
import { getPlainTextFromMarkup } from '../../common/models/styling'

const convertLanguage = language => {
  switch (language) {
    case LANGUAGE_EN:
    default:
      return LANGUAGE_EN_US
  }
}

export const getTranslatedProperty = (container, key, language) => {
  const languageConverted = convertLanguage(language)
  return container?.translatedValues?.[key]?.[languageConverted]
}

export const getDuplicateFormPayload = (form, language, copyText) => {
  const formName = getPlainTextFromMarkup(getTranslatedProperty(form, 'name', language))
  const newFormNameInfo = { [convertLanguage(language)]: formName.concat(' ', copyText) }
  return {
    'source_form_id': form.id,
    'overrides': {
      'name': { ...newFormNameInfo }
    }
  }
}
